export default __webpack_public_path__ + "static/gh-9783fb17fe4ab09dac16f06337dd6cf2.jpeg";